import React, { Fragment } from 'react'
import NavBar from '../NavBar/NavBar'
import Servises from '../Servises/Servises'
import Fany from '../Fany/Fany'
import img_home from '../../Image/صيّن.jpeg'
import vid from '../../Image/vid.mp4'
import './Home.css'

function Home() {
  return (
    <Fragment>
        <div className='home'>
            <div className='home_sec' >
                <div className='home_img'>
                    <img  src={img_home} />
                </div>
                <div className='home_text' >
                    <h1>صَيّن - Sayn</h1>
                    <p>
                        صَيّن هي احدي الشركات الرائده في الصيانه المنزليه الشامله والتشطيبات المنزليه
                    </p>
                </div>
            </div>
            <div className='home_video' >
                <video src={vid} type="video/mp4"   autoPlay />
            </div>
        </div>
        <Servises/>
    </Fragment>
  )
}

export default Home
